import { useFormState } from '../../../../../packages/kiti/components/form/form/FormHandler'

export const useShouldHideBondSelect = () => {
  const { form } = useFormState()
  return () => {
    const isFromNonCompliance = ['non_compliance'].includes(form.entity)
    // service_order_tag_assigned/removed despacham o mesmo registro achatado que service_order/event,
    // então o "Vínculo" (filha da atividade da automação / filha da atividade pai) é igualmente válido
    // para eles — mesmo raciocínio já aplicado ao "Tipo" em useShouldHideTypeSelect.
    const isFromServiceOrder = [
      'event',
      'service_order',
      'service_order_tag_assigned',
      'service_order_tag_removed'
    ].includes(form.entity)
    const isFromFormReply = ['form_reply'].includes(form.entity)

    return !isFromNonCompliance && !isFromServiceOrder && !isFromFormReply
  }
}

export const useShouldHideTypeSelect = () => {
  const { form } = useFormState()
  return () => {
    // service_order_tag_assigned/removed despacham o mesmo registro achatado que service_order/event
    // (não há non_compliance para vincular), então o seletor "Tipo" (Plano de ação vs Atividade) —
    // que só faz sentido quando dá pra vincular a atividade criada a uma não conformidade — deve ficar
    // escondido para esses gatilhos também. Sem essa entrada, o campo aparecia à toa em automações de
    // tag, fazendo a tela de "criar nova atividade" parecer a tela de criação de atividade via NC.
    const isFromServiceOrder = [
      'event',
      'service_order',
      'service_order_tag_assigned',
      'service_order_tag_removed'
    ].includes(form.entity)
    const isFromFormReply = ['form_reply'].includes(form.entity)

    return isFromServiceOrder || isFromFormReply
  }
}
